import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const BASE = "https://roomtemperature.io";

export default function Seo() {
  const { t, i18n, ready } = useTranslation();
  if (!ready) return null;

  const lang = i18n.language;

  const path = lang === "en" ? "" : `/${lang}`;
  const url = `${BASE}${path}`;

  return (
    <Helmet>
      {/* HTML lang */}
      <html lang={lang} />

      {/* Primary SEO */}
      <title>{t("seo.title")}</title>
      <meta name="description" content={t("seo.description")} />
      <meta name="keywords" content={t("seo.keywords")} />

      {/* Canonical */}
      <link rel="canonical" href={url} />

      {/* Hreflang for Google */}
      <link rel="alternate" hrefLang="en" href={`${BASE}/`} />
      <link rel="alternate" hrefLang="fr" href={`${BASE}/fr`} />
      <link rel="alternate" hrefLang="es" href={`${BASE}/es`} />
      <link rel="alternate" hrefLang="pt" href={`${BASE}/pt`} />
      <link rel="alternate" hrefLang="hi" href={`${BASE}/hi`} />
      <link rel="alternate" hrefLang="ar" href={`${BASE}/ar`} />
      <link rel="alternate" hrefLang="id" href={`${BASE}/id`} />
      <link rel="alternate" hrefLang="de" href={`${BASE}/de`} />
      <link rel="alternate" hrefLang="ja" href={`${BASE}/ja`} />
      <link rel="alternate" hrefLang="ru" href={`${BASE}/ru`} />
      <link rel="alternate" hrefLang="x-default" href={`${BASE}/`} />
    </Helmet>
  );
}